import { render, staticRenderFns } from "./stuclazz-view.vue?vue&type=template&id=01aec546&"
import script from "./stuclazz-view.vue?vue&type=script&lang=js&"
export * from "./stuclazz-view.vue?vue&type=script&lang=js&"
import style0 from "./stuclazz-view.vue?vue&type=style&index=0&id=01aec546&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports